module.exports = {
    gitVersion: '467055c394be0c6f371fe8e72bba595ff2de58d6',
    appVersion: '25.4.1',
};
